import { REGION } from "store/ref";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";

const app = getApp();
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  // :::::::::::: WITH MANAGER :::::::::::::://
  // rút tiền.
  const withdrawBailiffWallet = httpsCallable(
    functions,
    "api-payment-withdraw-order-generate"
  ); // {amount, source: bailiff, accountNumber, code, accountName}

  // thêm tài khoản.
  const bankAddAccount = httpsCallable(functions, "api-bank-add-account"); // { accountName, accountNumber, code }
  // xóa tài khoản.
  const bankDeleteAccount = httpsCallable(functions, "api-bank-delete-account"); // {id}

  // return.
  return {
    payment: {
      withdrawBailiffWallet,
    },
    bank: {
      bankAddAccount,
      bankDeleteAccount,
    },
  };
};
